import { gql } from '@apollo/client';

const PATCH_PREREQUISITE_MUTATION = gql`
    mutation patchPrerequisiteSet( $input:PatchPrerequisiteSetInput! ) {
        Result: patchPrerequisiteSet( input:$input ) {
            id
            objectId
            operator
            type
            prerequisites {
                objectId
                weight
            }
        }
    }`
;

export default PATCH_PREREQUISITE_MUTATION;
